import { render } from "./ExportToPDFComponent.vue?vue&type=template&id=2b99bb92&scoped=true&ts=true"
import script from "./ExportToPDFComponent.vue?vue&type=script&lang=ts"
export * from "./ExportToPDFComponent.vue?vue&type=script&lang=ts"

import "./ExportToPDFComponent.vue?vue&type=style&index=0&id=2b99bb92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b99bb92"]])

export default __exports__